import { useState } from 'react';
import LoadingIndicator from '../../Common/components/LoadingIndicator';
import useProcessing from './hooks/useProcessing';
import { useFormik } from 'formik';
import { Button } from '@/src/shadComponents/ui/button';
import { Label } from '@/src/shadComponents/ui/label';

export default function FlowTest({ flowDefinition, onClose }: any) {
    const [isLoading, setIsLoading] = useState(false);
    const [url, setUrl] = useState('');
    const { testFlow } = useProcessing();
    console.log('Flow definition: ', flowDefinition);
    const formik = useFormik({
        initialValues: {
            asset: '',
            flow: flowDefinition ? JSON.stringify(flowDefinition) : '',
        },
        onSubmit: async (...args) => {
            setIsLoading(true);
            // @ts-ignore
            const response = await testFlow(...args);
            setUrl(response.url);
            setIsLoading(false);
        },
    });

    return (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
            <div className="bg-background rounded-lg shadow-lg p-6 min-w-[500px]">
                <form
                    className="space-y-4"
                    onSubmit={formik.handleSubmit}
                    encType="multpart/form-data"
                >
                    <div className="flex gap-6">
                        <div className="flex-1 space-y-4">
                            <h2 className="text-lg font-semibold tracking-tight text-foreground">Test Flow</h2>

                            <div className="space-y-2">
                                <Label>File</Label>
                                <input
                                    type="file"
                                    name="asset"
                                    accept="*/*"
                                    className="text-sm file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-primary file:text-primary-foreground hover:file:bg-primary/90"
                                    onChange={(e) => {
                                        formik.setFieldValue(
                                            'asset',
                                            e.currentTarget.files?.[0],
                                        );
                                    }}
                                />
                            </div>
                            <input
                                type="hidden"
                                name="flow"
                                value={JSON.stringify(flowDefinition)}
                            />
                        </div>
                        <div className="flex items-center justify-center min-w-[200px]">
                            {isLoading ? (
                                <LoadingIndicator />
                            ) : url ? (
                                <img
                                    src={url}
                                    alt="preview"
                                    className="max-h-[200px]"
                                />
                            ) : null}
                        </div>
                    </div>
                    <div className="flex-1" />
                    <div className="flex justify-end gap-2 pt-4 border-t border-border">
                        <Button type="submit">
                            Upload &amp; Test
                        </Button>
                        <Button onClick={onClose} variant="outline">
                            Close
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
}
